import { isApolloError } from "@apollo/client/errors";
import { isError, replace, isString } from "lodash";

const graphqlErrorText = "GraphQL error: ";
export function wrapError(error: unknown): string {
  if (isString(error)) {
    return error;
  }

  if (isApolloError(error as Error)) {
    // Graphql likes to add its own error text before graphql errors, this doesn't help
    // the user in any way so we wil remove it
    return replace((error as Error).message, graphqlErrorText, "");
  }

  if (isError(error)) {
    return error.toString();
  }

  // de facto contract: callers treat the wrapped error as a string
  return error as string;
}
